import React from "react";
import { NavLink } from "react-router-dom";

import Checked from "../images/optimization.png";

// images
import Logo from "../images/25.png";

// components
import "antd/dist/antd.css";
import { Button, Row, Col, Affix, Divider } from "antd";

import { HomeOutlined } from "@ant-design/icons";

function Maintain() {
  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col span={21} style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>

      <div className="center">
        <br />
        <img src={Checked} alt="" width={80} />
        <br />
        <br />
        <p>ปิดปรับปรุงระบบชั่วคราว</p>
        {/* <p>จะกลับมาเปิดให้บริการเวลา 09:00 วันที่ 07/12/2022</p> */}
        <p>ขออภัยในความไม่สะดวก</p>
        <br />
        {/* <NavLink to="/">
          <Button
            shape="round"
            ghost
            type="primary"
            htmlType="submit"
            style={{ color:'#6D583A', borderColor:'#6D583A'}}
          >
            หน้าแรก <HomeOutlined />
          </Button>
        </NavLink> */}
      </div>
    </div>
  );
}

export default Maintain;
